// extracted by mini-css-extract-plugin
module.exports = {"search":"SelectDropdownSearchInput_search__O5IkN"};